import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { Timer, CheckCircle } from '@mui/icons-material';
import { useAuctionTimer } from '../hooks/useAuctionTimer';

const AuctionCountdown = ({ endTime, variant = 'default' }) => {
  const { timeLeft, isExpired, formatTimeLeft } = useAuctionTimer(endTime);

  if (variant === 'chip') {
    return (
      <Chip
        icon={isExpired ? <CheckCircle /> : <Timer />}
        label={formatTimeLeft()}
        color={isExpired ? 'default' : timeLeft?.total < 3600000 ? 'error' : 'primary'}
        size="small"
      />
    );
  }

  const getColor = () => {
    if (isExpired) return 'text.secondary';
    if (timeLeft?.total < 3600000) return 'error.main';
    if (timeLeft?.total < 86400000) return 'warning.main';
    return 'primary.main';
  };

  return (
    <Box display="flex" alignItems="center" gap={1}>
      {isExpired ? <CheckCircle color="disabled" /> : <Timer color="primary" />}
      <Typography variant="h6" color={getColor()} fontWeight="bold">
        {formatTimeLeft()}
      </Typography>
    </Box>
  );
};

export default AuctionCountdown;
